import { Node } from '../types'

export default function filterNodesByTriggeringPlacement(content: { nodes: Node[] }, triggerer?: string) {
  const checkoutNodesExist = content?.nodes.some(n => n.name.includes('CHECKOUT'))
  const allCheckoutNodesHaveValues = content?.nodes.every(n => !n.name.includes('CHECKOUT') || n.value !== '')
  let filterCondition

  if (allCheckoutNodesHaveValues && checkoutNodesExist && triggerer && triggerer.includes('checkout')) {
    filterCondition = (n: Node) => !n.name.includes('TIMELINE')
  } else {
    filterCondition = (n: Node) => !n.name.includes('CHECKOUT')
  }

  return { nodes: content.nodes.filter(filterCondition) }
}